import { useSelector } from 'react-redux'
import { selectMerchant } from 'selectors/merchant'

/**
 * Redux-ORM creates new model instances on every ORM state change, even
 * when the underlying data is identical.  shallowEqual is insufficient
 * because the Merchant model has nested objects (image_urls,
 * loyalty_transition_settings, etc.) that are fresh references each time.
 *
 * lodash/isEqual is also unsuitable: it traverses ORM model prototype
 * methods and internal bookkeeping, seeing identical data as different.
 * JSON.stringify compares only the serialisable data fields, which is
 * exactly the contract callers rely on.
 */
function jsonEqual(a: unknown, b: unknown): boolean {
  try {
    return JSON.stringify(a) === JSON.stringify(b)
  } catch {
    return false
  }
}

export default function useCurrentMerchant() {
  return useSelector(
    state =>
      //@ts-ignore
      selectMerchant(state, state.auth.current_merchant_id),
    jsonEqual
  )
}

export function useMerchantFeedbackEnabled() {
  const merchant = useCurrentMerchant()

  return merchant?.feedback_enabled ?? false
}
